import DataTable from "react-data-table-component";
import { PropagateLoader } from "react-spinners";
import NoData from "../../../../molecules/NoData";
import IconButton from "../../../../atoms/IconButton";
import { FaEye } from "react-icons/fa";
import { toast } from "react-toastify";
import { VIEW_FILE } from "../../../../../api/apiFiles";
import useModal from "../../../../../hooks/useModal";
import { useState } from "react";
import Modal from "../../../../molecules/Modal";

const AirbnbTable = ({ data, refetch, loading}) => {
    const [selected, setSelected] = useState(null);
    const [loadingView, setLoadingView] = useState();
    const [fileUrl, setFileUrl] = useState(null);
    const { open: openView, isOpen: isOpenView, close: closeView } = useModal();

    const handleClose = () => {
        closeView();
        setSelected(null);
    };

    const handleOpenView = async (s3Key) => {
        openView();
        setSelected(s3Key);
        setLoadingView(true);
        try {
            const response = await VIEW_FILE({ s3Key });
            if (response) {
                setFileUrl(response);
            } else {
                console.error("No se pudo obtener la URL del archivo");
            }
        } catch (error) {
            console.error("Error al cargar el archivo:", error);
            toast.error("Error al cargar el archivo");
        } finally {
            setLoadingView(false);
        }
    };

    const columns = [
        {
            name: "Servicio",
            cell: (row) => (row.name)
        },
        {
            name: "PDF del servicio",
            cell: (row) => (
                <IconButton
                    icon={FaEye}
                    bgColor="bg-rs-azul"
                    size="min-w-8 max-w-8" iconSize="text-2xl"
                    onClick={()=>handleOpenView(row.files.s3Key)}
                />
            ),
        },
    ];

    return (
        <>
            <DataTable
                data={data[0]?.documents}
                progressPending={loading}
                columns={columns}
                progressComponent={ <div className="w-full h-20 flex justify-center items-center"> <PropagateLoader color="red" /> </div> }
                noDataComponent={<NoData />}
                pagination
            />
            {isOpenView && selected &&
                <Modal title="Factura" onClose={handleClose}>
                    {loadingView ?
                            <PropagateLoader color="red" />
                        :
                            <iframe src={fileUrl} title="Factura" className="w-full h-[85vh]" />
                    }
                </Modal>
            }
        </>
    );
};

export default AirbnbTable;